import * as React from 'react';
import { connect } from 'react-redux';

import ButtonLink from 'components/ButtonLink';
import { updateQueryString } from 'services/router/actions';
import { TIMESHEET_UNAPPROVE_MODAL } from 'scenes/Time/components/TimesheetUnapproveModal';

interface OwnProps {
    timesheetId: number;
}

interface DispatchProps {
    updateQueryString: typeof updateQueryString;
}

type Props = OwnProps & DispatchProps;

export class TimesheetUnapproveLinkComponent extends React.PureComponent<Props> {
    handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        event.stopPropagation();
        const { timesheetId } = this.props;

        this.props.updateQueryString({
            selectedTimesheet: timesheetId,
            [TIMESHEET_UNAPPROVE_MODAL]: true
        });
    };

    render(): React.ReactElement {
        return <ButtonLink onClick={this.handleClick}>Unapprove</ButtonLink>;
    }
}

export default connect(null, { updateQueryString })(
    TimesheetUnapproveLinkComponent
);
